export const ALLOWED_BRANDS = ["normal", "chicago", "texashealth"];
export const DEFAULT_BRAND = "normal";

const normalizeBrand = (brand) =>
  typeof brand === "string" ? brand.trim().toLowerCase() : "";

export const getValidatedBrand = (brand) => {
  const normalizedBrand = normalizeBrand(brand);
  // Keep the existing internal theme name while sharing MyChart's URL value.
  if (normalizedBrand === "texashealth") return "texas";
  return ALLOWED_BRANDS.includes(normalizedBrand)
    ? normalizedBrand
    : DEFAULT_BRAND;
};

export const getBrandFromUrl = (search = window.location.search) => {
  const queryParams = new URLSearchParams(search);
  const explicitBrand = normalizeBrand(queryParams.get("brand"));
  if (ALLOWED_BRANDS.includes(explicitBrand)) return getValidatedBrand(explicitBrand);
  if (normalizeBrand(queryParams.get("website")) === "texashealth") return "texas";
  return getValidatedBrand(queryParams.get("brand"));
};

export const applyActiveBrand = (search = window.location.search) => {
  const activeBrand = getBrandFromUrl(search);
  document.documentElement.dataset.brand = activeBrand;
  return activeBrand;
};
